import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'IrisCategoriesPicker',
  props: {
    value: { default: () => [] },
    disabled: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: any[]): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: any[], disabled: boolean };





return { __sfc: true,props, emit }
}

})